// extracted by mini-css-extract-plugin
export var radioInputRow = "w_sS";
export var radioInputColumn = "w_sT";
export var inputOptionRow = "w_qq";
export var inputOptionColumn = "w_qr";